import { z } from 'zod';

export const CardDetailsSchema = z.object({
  numberFirstN: z.string(),
  numberLastN: z.string(),
});

export const DigitalWalletSchema = z.object({
  walletsEnabled: z.boolean(),
  pushProvisioningEnabled: z.boolean(),
});

export const CardOwnerSchema = z.object({
  ownerUserId: z.string(),
  ownerOrganisationId: z.string(),
  nameOnCard: z.string(),
  nameOnCardLineTwo: z.string(),
});

export const BillingAddressSchema = z.object({
  streetOne: z.string(),
  city: z.string(),
  zipCode: z.string(),
  country: z.string(),
});

export const ThreeDSConfigSchema = z.object({
  primaryChannel: z.string(),
});

export const ConfigInfoSchema = z.object({
  cardConfigId: z.string(),
  cardIssuerName: z.string(),
  externalSupportHandle: z.string(),
  tags: z.array(z.string()),
});

export const CardSchema = z.object({
  id: z.string(),
  brand: z.string(),
  type: z.string(),
  fundsMode: z.string(),
  state: z.string(),
  issuer: z.string(),
  currency: z.string(),
  friendlyName: z.string(),
  linkedFundsAccountId: z.string(),
  cardCreationTimestamp: z.string(),
  cardDetails: CardDetailsSchema,
  digitalWallet: DigitalWalletSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
  owner: CardOwnerSchema,
  billingAddress: BillingAddressSchema,
  threeDSConfig: ThreeDSConfigSchema,
  configInfo: ConfigInfoSchema,
});

export const CardsResponseSchema = z.object({
  cards: z.array(CardSchema),
});

// Export inferred types
export type CardDetails = z.infer<typeof CardDetailsSchema>;
export type DigitalWallet = z.infer<typeof DigitalWalletSchema>;
export type CardOwner = z.infer<typeof CardOwnerSchema>;
export type BillingAddress = z.infer<typeof BillingAddressSchema>;
export type ThreeDSConfig = z.infer<typeof ThreeDSConfigSchema>;
export type ConfigInfo = z.infer<typeof ConfigInfoSchema>;
export type Card = z.infer<typeof CardSchema>;
export type CardsResponse = z.infer<typeof CardsResponseSchema>;
